import lazyLoadView from "@router-utils/lazyload-view";
import routeError from "@router-utils/route-error";
import { redirectIfHotelDisabled } from '@router-utils/require-hotel-enabled'
import { MEMBER_ORDER_CONTAINER_DETAIL } from '@utils/member-order-container'
import store from '@store'

export default [
  // ===
  // 會員中心
  // ===
  {
    path: '/member',
    name: 'member',
    component: () => lazyLoadView(import('@views/Member/Index.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          await store.dispatch('auth/fetchMember');

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginPage: true,
    }
  },
  // ===
  // 預約紀錄
  // ===
  {
    path: '/member/reservation',
    name: 'member-reservation',
    component: () => lazyLoadView(import('@views/Member/ReservationList.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginPage: true,
    }
  },
  // ===
  // 住宿記錄
  // ===
  {
    path: '/member/hotel',
    name: 'member-hotel',
    component: () => lazyLoadView(import('@views/Member/HotelList.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const redirected = await redirectIfHotelDisabled(next)
          if (redirected) return
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginPage: true,
    }
  },
  // ===
  // 住宿記錄 內容頁
  // ===
  {
    path: '/member/hotel/:uuid',
    name: 'member-hotel-item',
    component: () => lazyLoadView(import('@views/Member/ReservationItem.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const redirected = await redirectIfHotelDisabled(next)
          if (redirected) return
          const [
            currentReservationOrderItem
          ] = await Promise.all([
            store.dispatch('order/fetchHotelContainerOrderItem', {
              containerUuId: routeTo.params.uuid,
              errorHandle: false,
              showMessage: false,
              logoutRedirect: false,
              name: MEMBER_ORDER_CONTAINER_DETAIL,
            }),
          ])
          const isTemp = currentReservationOrderItem?.is_temp ?? currentReservationOrderItem?.items?.is_temp
          if (isTemp) {
            alert('此訂單尚未成預約，無法查看')
            return next({ name: 'reservation-checkout' })
          }
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginPage: true,
    },
    props: (route) => ({}),
  },
  // // ===
  // // 預約紀錄 內容頁
  // // ===
  // {
  //   path: '/member/reservation/:orderId',
  //   name: 'member-reservation-item',
  //   component: () => lazyLoadView(import('@views/Member/ReservationItem.Jtails')),
  //   meta: {
  //     async beforeResolve(routeTo, routeFrom, next) {
  //       try {
  //         const [
  //           currentReservationOrderItem
  //         ] = await Promise.all([
  //           store.dispatch('order/fetchReservationOrderItem', {
  //             orderId: routeTo.params.orderId
  //           }),
  //         ]);

  //         routeTo.params.orderItem = currentReservationOrderItem.items;

  //         next()
  //       } catch (error) {
  //         routeError(error, routeTo, next({ name: '404' }), next);
  //       }
  //     },
  //     isLoginPage: true,
  //   },
  //   props: (route) => ({
  //     orderItem: route.params.orderItem || {},
  //   }),
  // },
  // ===
  // 新版預約紀錄 內容頁
  // ===
  {
    path: '/member/reservation/:containerUuid',
    name: 'member-reservation-item',
    component: () => lazyLoadView(import('@views/Member/ReservationItem.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentReservationOrderItem
            
          ] = await Promise.all([
            store.dispatch('order/fetchContainerOrderItem', {
              containerUuId: routeTo.params.containerUuid,
              errorHandle: false,
              showMessage: false,
              logoutRedirect: false,
              name: MEMBER_ORDER_CONTAINER_DETAIL,
            }),
            // store.dispatch('auth/fetchMemberPetList', {
            //   useCached: true
            // })
          ])
          // API 回傳 data 為容器，request 已解出為容器物件；容器頂層有 is_temp
          const isTemp = currentReservationOrderItem?.is_temp ?? currentReservationOrderItem?.items?.is_temp
          if (isTemp) {
            alert('此訂單尚未成預約，無法查看')
            return next({ name: 'reservation-checkout' })
          } 
          // routeTo.params.orderItem = currentReservationOrderItem.items;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginPage: true,
    },
    props: (route) => ({
      // containerItem: route.params.orderItem || {},
    }),
  },
  // ===
  // 包套方案
  // ===
  {
    path: '/member/prepaid',
    name: 'member-prepaid',
    component: () => lazyLoadView(import('@views/Member/PrepaidList.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginPage: true,
    }
  },
  // ===
  // 包套方案 內容頁
  // ===
  {
    path: '/member/prepaid/:prepaidOrderId',
    name: 'member-prepaid-item',
    component: () => lazyLoadView(import('@views/Member/PrepaidItem.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentPrepaidOrderItem
          ] = await Promise.all([
            store.dispatch('order/fetchPrepaidOrderItem', {
              prepaidOrderId: routeTo.params.prepaidOrderId
            }),
          ]);

          routeTo.params.orderItem = currentPrepaidOrderItem.items;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginPage: true,
    },
    props: (route) => ({
      orderItem: route.params.orderItem || {},
    }),
  },
  // ===
  // 儲值金
  // ===
  {
    path: '/member/deposit',
    name: 'member-deposit',
    component: () => lazyLoadView(import('@views/Member/DepositList.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          if(!store.state.merchant.currentMerchant?.components.includes('deposit')) {
            next({ name: '404' })
          }
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginPage: true,
    }
  },
  // ===
  // 儲值金 內容頁
  // ===
  {
    path: '/member/deposit/:depositOrderId',
    name: 'member-deposit-item',
    component: () => lazyLoadView(import('@views/Member/DepositItem.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentDepositContainerItem
          ] = await Promise.all([
            store.dispatch('order/fetchContainerOrderItem', {
              containerUuId: routeTo.params.depositOrderId
            }),
          ]);

          // API 回傳 { data: { 容器 } }，request 可能回傳內層 data 或整包；部分情境為 { items: 容器 }
          const raw = currentDepositContainerItem?.data ?? currentDepositContainerItem?.items ?? currentDepositContainerItem;
          routeTo.params.containerItem = raw ?? {};

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginPage: true,
    },
    props: (route) => ({
      containerItem: route.params.containerItem || {},
    }),
  },
  // ===
  // 會員設定
  // ===
  {
    path: '/member/info',
    name: 'member-info',
    component: () => lazyLoadView(import('@views/Member/Info.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          await store.dispatch('auth/fetchMember');

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginPage: true,
    }
  },
  // ===
  // 寵物資料
  // ===
  {
    path: '/member/pet',
    name: 'member-pet',
    component: () => lazyLoadView(import('@views/Member/Pet.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLoginPage: true,
      modePage: 'jtails'
    },
  },  
  // {
  //   path: '/member/user',
  //   name: 'member-pet',
  //   component: () => lazyLoadView(import('@views/Member/Pet.Jtails')),
  //   meta: {
  //     async beforeResolve(routeTo, routeFrom, next) {
  //       try {

  //         next()
  //       } catch (error) {
  //         routeError(error, routeTo, next({ name: '404' }), next);
  //       }
  //     },
  //     isLoginPage: true,
  //     modePage: 'dingbeauty'
  //   },
  // },
]
